// Keep failures understandable and the timeout active until the body is read.
export async function requestJson(url, options = {}) {
  const { timeoutMs = 20_000, signal, ...init } = options;
  const controller = new AbortController();
  const cancel = () => controller.abort();
  if (signal?.aborted) cancel();
  signal?.addEventListener("abort", cancel, { once: true });
  const timeout = setTimeout(cancel, timeoutMs);
  try {
    const response = await fetch(url, { ...init, signal: controller.signal });
    let payload;
    try {
      payload = await response.json();
    } catch (error) {
      if (controller.signal.aborted) throw error;
      throw new Error("We couldn't read the response. Please try again.");
    }
    if (!response.ok) {
      const message = response.status === 429
        ? "Too many attempts. Please wait a minute, then try again."
        : response.status >= 500
          ? "We couldn't complete that request right now. Please try again."
          : payload.error || "We couldn't complete that request. Please try again.";
      throw Object.assign(new Error(message), { status: response.status });
    }
    return payload;
  } catch (error) {
    if (controller.signal.aborted) throw new Error("This is taking longer than expected. Please try again.");
    if (error?.name === "TypeError") throw new Error("We couldn't connect. Check your connection and try again.");
    throw error;
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", cancel);
  }
}
